import React, { useEffect, useState } from "react";
import { getSocket } from "../../../../../../helpers/SingletonSocketService";

function MobileLiveStatus({item, profile}) {
  const [highestBidder, setHighestBidder] = useState(false);

  useEffect(() => {
      const socket = getSocket();
      socket?.on("newBid", (data) => {
        if (
          data?.offerId === item?._id &&
          data?.bidDetails?.organization === profile?.organization
        ) {
          setHighestBidder(true);
        } else if (data?.offerId === item?._id) {
          setHighestBidder(false);
        }
      });
    }, [profile, item, setHighestBidder]);
  
    useEffect(() => {
      if (item) {
        if (item?.highestBid === item?.myCurrentBidAmount && item?.myCurrentBidAmount !== 0) {
          setHighestBidder(true);
        } else {
          setHighestBidder(false);
        }
      }
  
    }, [profile, item, setHighestBidder]);

  return (
    <div className="full-width valign-wrapper justify-center">
      {highestBidder
        ? "You are highest bidder 💥"
        : "You are not highest bidder ⚠️"}
    </div>
  );
}

export default MobileLiveStatus;
